import throttle from 'lodash.throttle';

const INITIALISED_CLASS = 'header-toggler--initialised';
const SCROLL_DOWN_KEY = 'scroll-down';
const SCROLL_UP_KEY = 'scroll-up';

export default class HeaderToggler {
  /**
   * @param {JQuery | HTMLElement | string } element - Selector with elements which will receive the scroll state classes
   */
  constructor(element) {
    this.lastScroll = 0;
    this.lastScrollWasDown = false;
    this.scrollTimer = undefined;
    this.resizeTimer = undefined;
    this.element = jQuery(element);
    this.throttledScrollHandler = throttle(this.scrollHandler.bind(this), 300);
    this.throttledResizeHandler = throttle(this.resizeHandler.bind(this), 300);
  }

  init() {
    jQuery(window).on('scroll', this.throttledScrollHandler);
    jQuery(window).on('resize', this.throttledResizeHandler);
    this.offsetNextSibling();
    jQuery(() => {
      this.offsetNextSibling();
    });
    jQuery(window).on('load', () => {
      this.offsetNextSibling();
    });
    this.element.addClass(INITIALISED_CLASS);
  }

  scrollHandler() {
    const scrolledDown = this.scrollTop - this.lastScroll > 0;

    this.lastScroll = this.scrollTop;
    this.lastScrollWasDown = scrolledDown;

    this.toggleClassesOnDirection(scrolledDown, this.scrollTop);
  }

  get scrollTop() {
    return jQuery(window).scrollTop();
  }

  resizeHandler() {
    this.offsetNextSibling();
  }

  offsetNextSibling() {
    const heightOffset = this.element.height();

    this.getRelativelyPositionedSibling().css('margin-top', Math.floor(heightOffset));
  }

  getRelativelyPositionedSibling() {
    return this.element
      .nextAll()
      .filter((i, el) => ['static', 'relative'].includes(jQuery(el).css('position')))
      .eq(0);
  }

  toggleClassesOnDirection(scrolledDown, scrollPosition) {
    const scrollToggleActive = scrollPosition > this.element.height();
    const stickingPoint = this.element.height();

    if (scrolledDown) {
      if (scrollToggleActive) {
        this.element.addClass(SCROLL_DOWN_KEY).removeClass(SCROLL_UP_KEY);
        jQuery('.block--vam-cp-client-page.block--menu-block').addClass(SCROLL_DOWN_KEY).removeClass(SCROLL_UP_KEY);
        jQuery('.block--vam-cp-client-page.block--menu-block').css('top', 0);
      }
    } else {
      this.element.addClass(SCROLL_UP_KEY).removeClass(SCROLL_DOWN_KEY);
      jQuery('.block--vam-cp-client-page.block--menu-block').addClass(SCROLL_UP_KEY).removeClass(SCROLL_DOWN_KEY);
      jQuery('.block--vam-cp-client-page.block--menu-block').css('top', stickingPoint);
    }

    this.offsetNextSibling();
  }
}
